/* Surcharges des skins liées à l'affichage RTL */
import {IReg, REG} from "/@lib@/commons/registry.js";


export function ovrReg(reg: IReg<any>) {

	reg.overlaySkin("usersmgr-users", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  .ctrlLbl[area-id=isHidden] > .lbl::before,
	  .ctrlLbl[area-id=isDisabled] > .lbl::before {
		  background-position: right;
	  }
	`);

	reg.overlaySkin("c-userref", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host([data-withIcon]) span {
		  background-position: right;
	  }
	`);

	reg.overlaySkin("c-workbench", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  #tabsLT > button,
	  #tabsLB > button,
	  #tabsBL > button.sibling {
		  background-image: url('/@skin@/core/widgets/workbench/closeToolR.svg');
		  min-width: var(--icon-size);
		  min-height: var(--icon-size);
	  }

	  #tabsRT > button,
	  #tabsRB > button,
	  #tabsBR > button.sibling {
		  background-image: url('/@skin@/core/widgets/workbench/closeToolL.svg');
		  min-width: var(--icon-size);
		  min-height: var(--icon-size);
	  }
	`);


}